import { message } from "antd";
import { useState } from "react";
import { generateOrderStateReportOrdersByClientEvent } from "../../_events/orders/find_order.event";
import { downloadExcelFile } from "../../_utils/download_file.util";

export const useDownoadExcelOrderByClient = () => {

    const [ loading, setLoading ] = useState(false);

    const downloadExcel = (uuidClient) => {
        if(! uuidClient){
            message.error('Sin cliente');
        } else {
            setLoading(true);
            generateOrderStateReportOrdersByClientEvent(uuidClient)
            .then(json => {
                console.log(json);
                setLoading(false);
                downloadExcelFile(json.data.bytes, `listado_pedidos_${new Date().toISOString()}`);
            })
            .catch(err => {
                message.error(err.message);
                setLoading(false);
            });
        }
    }

    return {
        loading, downloadExcel
    };
}